var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("DateSelectProps", {
        ref: "dateSelect",
        attrs: {
          selectedDate: _vm.selectedDate,
          disabled: true,
          noShotCuts: true,
          disabledDatesBefore: _vm.disabledDates,
        },
      }),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.textReason,
            expression: "textReason",
          },
        ],
        staticClass: "form-control mt-2",
        attrs: { placeholder: "Комментарий к действию" },
        domProps: { value: _vm.textReason },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.textReason = $event.target.value
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }